import React, { useState, ChangeEvent } from 'react';
import { Modal } from 'react-bootstrap';

import { formTitle } from 'helpers/forms';
import SVButton from 'components/elements/SVButton';

type ESSubmitConfirmationProps = {
  onSubmit: () => void;
  onCancel: () => void;
};

const ESSubmitConfirmation: React.FC<ESSubmitConfirmationProps> = ({ onSubmit, onCancel }) => {
  const [satisfied, setSatisfied] = useState(false);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSatisfied(event.target.checked);
  };

  return (
    <Modal show onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>
          {`Are you sure you want to submit ‘${formTitle.meetingRounds}’ form?`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <input
            type="checkbox"
            style={{ marginRight: '1rem' }}
            onChange={handleCheckboxChange}
          />
          I am satisfied with the answers given in this form and wish to submit
          for review.
        </p>
        <p>This cannot be undone.</p>
      </Modal.Body>
      <Modal.Footer>
        <SVButton variant="cancel" onClick={onCancel}>
          Cancel
        </SVButton>
        <SVButton
          size="sm"
          variant="secondary"
          onClick={onSubmit}
          disabled={!satisfied}
        >
          Submit
        </SVButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ESSubmitConfirmation;
